/******************************************************************************** 
    Setup Visible Section Detection
**********************************************************************************/

// Section visibility detection - ONLY handles .visible-section class management
document.addEventListener('DOMContentLoaded', function() {
    // Function to detect when sections are visible and add/remove .visible-section class
    function initSectionVisibilityDetection() {
        const sections = document.querySelectorAll('.shopify-section');
        
        if (sections.length === 0) return;
        
        // Create intersection observer for section visibility
        const sectionObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const section = entry.target;
                
                if (entry.isIntersecting) {
                    // Section is visible - add visible class
                    section.classList.add('visible-section');
                } else {
                    // Section is not visible - remove visible class
                    section.classList.remove('visible-section');
                }
            });
        }, {
            threshold: 0.3, // Trigger when 30% of section is visible
            rootMargin: '0px'
        });
        
        // Observe all sections
        sections.forEach(section => {
            sectionObserver.observe(section);
        });
    }
    
    // Initialize the section visibility detection
    initSectionVisibilityDetection();
});



/******************************************************************************** 
    Format NAD+ Text to NAD with Superscript +
**********************************************************************************/

    // Function to convert NAD+ and NAD⁺ text to NAD with superscript +
    function formatNADPlus() {
    
        // Get all text nodes in the document
        const walker = document.createTreeWalker(
            document.body,
            NodeFilter.SHOW_TEXT,
            {
                acceptNode: function(node) {
                    // Skip script and style tags
                    if (node.parentElement.tagName === 'SCRIPT' || 
                        node.parentElement.tagName === 'STYLE') {
                    return NodeFilter.FILTER_REJECT;
                    }
                    // Only process nodes that contain "NAD+" or "NAD⁺"
                    return (node.textContent.includes('NAD+') || node.textContent.includes('NAD⁺')) ? 
                    NodeFilter.FILTER_ACCEPT : 
                    NodeFilter.FILTER_REJECT;
                }
            }
        );
  
        const nodesToReplace = [];
        let node;
    
        // Collect all text nodes containing "NAD+" or "NAD⁺"
        while (node = walker.nextNode()) {
            nodesToReplace.push(node);
        }
  
        // Replace each occurrence
        nodesToReplace.forEach(textNode => {
            const parent = textNode.parentElement;
            let text = textNode.textContent;
        
            // Replace NAD⁺ with NAD+ first to normalize
            text = text.replace(/NAD⁺/g, 'NAD+');
            
            // Use regex to find and replace NAD+ while preserving exact positions
            const regex = /NAD\+/g;
            const fragment = document.createDocumentFragment();
            let lastIndex = 0;
            let match;
        
            while ((match = regex.exec(text)) !== null) {
                // Add text before the match (preserving ALL spacing exactly as-is)
                if (match.index > lastIndex) {
                    fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
                }
                
                // Add "NAD" as text
                fragment.appendChild(document.createTextNode('NAD'));
                
                // Add "+" as superscript only
                const sup = document.createElement('sup');
                sup.textContent = '+';
                sup.style.fontSize = '0.75em';
                sup.style.lineHeight = '0.5em';
                sup.style.verticalAlign = 'super';
                fragment.appendChild(sup);
                
                lastIndex = regex.lastIndex;
            }
            
            // Add any remaining text after the last match
            if (lastIndex < text.length) {
                fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
            }
            
            // Replace the original text node with the new fragment
            parent.replaceChild(fragment, textNode);
        });
    }
  
    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', formatNADPlus);
    } else {
        formatNADPlus();
    }
  
    // Run again after a short delay to catch Shopify's dynamically loaded content
    setTimeout(formatNADPlus, 500);
    setTimeout(formatNADPlus, 1000);
    setTimeout(formatNADPlus, 2000);
  
    // Watch for dynamically added content (for AJAX updates, infinite scroll, etc.)
    const observer = new MutationObserver(function(mutations) {
        let shouldRun = false;

        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length) {
                // Check if any added nodes contain text
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE) {
                        shouldRun = true;
                    }
                });
            }
        });

        if (shouldRun) {
            formatNADPlus();
        }
    });
  
    // Start observing after DOM is ready
    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            observer.observe(document.body, {
            childList: true,
            subtree: true
            });
        });
    }




/********************************************************************************
    Shopify Forms Preloader - Simple Version
**********************************************************************************/

document.addEventListener('DOMContentLoaded', function() {
    // Find all Shopify Forms containers
    const formContainers = document.querySelectorAll('[data-forms-id]');
    
    if (formContainers.length === 0) return;
    
    formContainers.forEach(function(formContainer) {
        // Skip if preloader already exists
        if (formContainer.querySelector('.shopify-form-preloader')) return;
        
        // Skip if form is inside footer
        if (formContainer.closest('.shopify-section-group-footer-group')) return;
        
        // Create preloader
        const preloader = document.createElement('div');
        preloader.className = 'shopify-form-preloader';
        preloader.innerHTML = `
            <div style="
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(255, 255, 255, 0.9);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 15px;
                z-index: 1000;
                border-radius: 8px;
                pointer-events: none;
            ">
                <div style="
                    width: 40px;
                    height: 40px;
                    border: 4px solid #f3f3f3;
                    border-top: 4px solid #062f56;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                "></div>
                <div style="
                    color: #062f56;
                    font-size: 16px;
                    font-weight: 500;
                    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                ">Loading form...</div>
            </div>
            <style>
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `;
        
        // Setup container
        if (window.getComputedStyle(formContainer).position === 'static') {
            formContainer.style.position = 'relative';
        }
        formContainer.style.minHeight = '400px';
        formContainer.appendChild(preloader);
        
        // Simple check function
        function checkAndRemove() {
            const formEmbed = formContainer.querySelector('form-embed');
            if (formEmbed && formEmbed.shadowRoot) {
                const form = formEmbed.shadowRoot.querySelector('form[data-testid="form"]');
                if (form && form.querySelectorAll('input, select, textarea').length > 0) {
                    // Set width 100% on data-sizing="form-wrapper" elements
                    const formWrappers = formEmbed.shadowRoot.querySelectorAll('[data-sizing="form-wrapper"]');
                    formWrappers.forEach(function(wrapper) {
                        wrapper.style.width = '99%';
                        wrapper.style.maxWidth = '99%';
                    });
                    
                    // Set width 100% on #form-container-ref
                    const formContainerRef = formEmbed.shadowRoot.querySelector('.rbsv2-columns__app-block #form-container-ref');
                    if (formContainerRef) {
                        formContainerRef.style.width = '99%';
                        formContainerRef.style.maxWidth = '99%';
                    }
                    
                    // Form loaded - remove preloader
                    preloader.style.transition = 'opacity 0.3s ease';
                    preloader.style.opacity = '0';
                    setTimeout(() => preloader.remove(), 300);
                    return true;
                }
            }
            return false;
        }
        
        // Watch for changes
        const observer = new MutationObserver(checkAndRemove);
        observer.observe(formContainer, { childList: true, subtree: true });
        
        // Periodic checks
        const interval = setInterval(() => {
            if (checkAndRemove()) {
                clearInterval(interval);
                observer.disconnect();
            }
        }, 200);
        
        // Function to check if form loaded and reload if not
        function checkFormAndReload() {
            const formEmbed = formContainer.querySelector('form-embed');
            let formHasContent = false;
            
            // Check if form has actual content
            if (formEmbed && formEmbed.shadowRoot) {
                const form = formEmbed.shadowRoot.querySelector('form[data-testid="form"]');
                if (form && form.querySelectorAll('input, select, textarea').length > 0) {
                    formHasContent = true;
                }
            }
            
            // If form has no content after 10 seconds, reload once
            if (!formHasContent) {
                const reloadCount = parseInt(sessionStorage.getItem('shopify_form_reload_count') || '0');
                
                if (reloadCount < 1) {
                    sessionStorage.setItem('shopify_form_reload_count', '1');
                    console.log('Shopify Form failed to load after 10 seconds, reloading...');
                    window.location.reload();
                } else {
                    console.log('Shopify Form still not loaded after reload, giving up');
                    // Clear counter after 2 minutes
                    setTimeout(() => {
                        sessionStorage.removeItem('shopify_form_reload_count');
                    }, 120000);
                }
            } else {
                // Form loaded successfully, clear reload counter
                sessionStorage.removeItem('shopify_form_reload_count');
            }
        }
        
        // Check after 10 seconds
        setTimeout(checkFormAndReload, 10000);
        
        // Failsafe removal after 10 seconds
        setTimeout(() => {
            clearInterval(interval);
            observer.disconnect();
            if (preloader.parentNode) {
                preloader.style.opacity = '0';
                setTimeout(() => preloader.remove(), 300);
            }
        }, 10000);
    });
});


/******************************************************************************** 
    Smart Cart Toggle
**********************************************************************************/

    function toggleCartIcons() {
        const body = document.body;
        const smartCartIcon = document.getElementById('cart-icon-bubble-smart');
        const regularCartIcon = document.getElementById('cart-icon-bubble');
        const fallbackToCart = function() {
            window.location.href = window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
        };
        
        if (!smartCartIcon || !regularCartIcon) return;
        
        if (body.classList.contains('smart-cart--enabled')) {
            // Show smart cart icon, hide regular cart icon
            smartCartIcon.style.display = '';
            regularCartIcon.style.display = 'none';
            
            // Add click handler for smart cart (only once)
            if (!smartCartIcon.hasAttribute('data-smart-cart-bound')) {
                smartCartIcon.setAttribute('data-smart-cart-bound', 'true');
                smartCartIcon.addEventListener('click', function() {
                    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
                        Rebuy.SmartCart.show();
                        return;
                    }
                    if (typeof window.loadRbsRebuy === 'function') {
                        window.loadRbsRebuy().then(function() {
                            if (window.Rebuy && window.Rebuy.SmartCart) {
                                window.Rebuy.SmartCart.show();
                            } else {
                                fallbackToCart();
                            }
                        }).catch(function(error) {
                            console.error('Failed to load Rebuy Smart Cart:', error);
                            fallbackToCart();
                        });
                    } else {
                        fallbackToCart();
                    }
                });
            }
        } else {
            // Show regular cart icon, hide smart cart icon
            smartCartIcon.style.display = 'none';
            regularCartIcon.style.display = '';

            if (!regularCartIcon.hasAttribute('data-rebuy-cart-bound')) {
                regularCartIcon.setAttribute('data-rebuy-cart-bound', 'true');
                regularCartIcon.addEventListener('click', function(event) {
                    if (typeof window.loadRbsRebuy !== 'function') return;
                    event.preventDefault();
                    window.loadRbsRebuy().then(function() {
                        if (window.Rebuy && window.Rebuy.SmartCart) {
                            window.Rebuy.SmartCart.show();
                            toggleCartIcons();
                        } else {
                            fallbackToCart();
                        }
                    }).catch(function(error) {
                        console.error('Failed to load Rebuy Smart Cart:', error);
                        fallbackToCart();
                    });
                });
            }
        }
    }

    // Run on page load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', toggleCartIcons);
    } else {
        toggleCartIcons();
    }

    // Pre-load Rebuy 2 seconds after page load so SmartCart is ready before first click
    setTimeout(function() {
        if (typeof window.loadRbsRebuy === 'function') {
            window.loadRbsRebuy().catch(function() {});
        }
    }, 2000);

    // Watch for dynamic class changes on body
    const bodyObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                toggleCartIcons();
            }
        });
    });

    // Start observing body for class changes
    if (document.body) {
        bodyObserver.observe(document.body, {
            attributes: true,
            attributeFilter: ['class']
        });
    } else {
        document.addEventListener('DOMContentLoaded', function() {
            bodyObserver.observe(document.body, {
                attributes: true,
                attributeFilter: ['class']
            });
        });
    }
